import React from 'react';
import { Link } from 'react-router-dom';
import { FiCode, FiBook, FiTrendingUp, FiAward, FiPlay, FiUsers } from 'react-icons/fi';

const Home = () => {
  const features = [
    {
      icon: <FiBook />,
      title: 'Comprehensive Content',
      description: 'Learn C# and .NET Core from basics to advanced topics with structured lessons and examples.'
    },
    {
      icon: <FiPlay />,
      title: 'Interactive Learning',
      description: 'Practice with live code editors, run examples in your browser, and get instant feedback.'
    },
    {
      icon: <FiUsers />,
      title: 'Fun Analogies',
      description: 'Understand complex concepts through cricket, football, and sports scenarios that make learning enjoyable!'
    },
    {
      icon: <FiTrendingUp />,
      title: 'Progress Tracking',
      description: 'Track your learning journey, bookmark topics, and see how far you\'ve come.'
    },
    {
      icon: <FiAward />,
      title: 'Quizzes & Challenges',
      description: 'Test your knowledge with interactive quizzes and earn achievements as you learn.'
    },
    {
      icon: <FiCode />,
      title: 'Real Code Examples',
      description: 'Learn from practical, real-world examples using relatable scenarios and fun character names.'
    }
  ];

  return (
    <div>
      <div className="home-hero">
        <h1 className="hero-title">Learn Programming the Fun Way! 🎮</h1>
        <p className="hero-subtitle">
          Master C# and .NET Core with sports analogies, interactive examples, and gamified learning
        </p>
        <div className="hero-cta">
          <Link to="/topic/csharp/basics/introduction" className="btn btn-primary">
            <FiPlay /> Start Learning C#
          </Link>
          <Link to="/topic/dotnet/fundamentals/introduction" className="btn btn-outline">
            <FiCode /> Explore .NET Core
          </Link>
        </div>
      </div>

      <div className="feature-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="content-section">
        <h2 className="section-title">Why JustDoCode?</h2>
        <div className="section-content">
          <p>
            Learning to code doesn't have to be boring! At JustDoCode, we believe that programming concepts 
            are easier to understand when explained through familiar, real-life scenarios.
          </p>
          <p>
            Imagine learning Object-Oriented Programming through a cricket team structure, where players are objects, 
            batting and bowling are methods, and team statistics are properties. Or understanding inheritance by 
            seeing how a Batsman class inherits from a Player base class!
          </p>
          <p>
            Our interactive platform combines structured learning with hands-on practice, making every concept 
            stick through fun analogies and memorable examples. Whether you're a complete beginner or looking 
            to advance your skills, JustDoCode makes the journey enjoyable! 🚀
          </p>
        </div>
      </div>

      <div className="analogy-card">
        <h3 className="analogy-title">🏏 Learning Example: Classes as Cricket Players</h3>
        <div className="analogy-content">
          Think of a Class as a cricket player template. Just like every player has a name, jersey number, 
          and can bat or bowl, every class has properties (data) and methods (actions). When you create a 
          new player object, you're bringing that template to life - just like selecting a player for your team! 
          This is how we make coding concepts fun and relatable at JustDoCode.
        </div>
      </div>
    </div>
  );
};

export default Home;

